import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BodyText, String, Ui } from "@silvertours/front-shared";
import { Runtime } from "@silvertours/front-entities";
import { format } from "date-fns/format";
import { differenceInCalendarDays } from "date-fns/differenceInCalendarDays";
import { parseISO } from "date-fns/parseISO";
import { Category, Dates, Details, Pricing } from "./OfferDetails.styles";
var OfferDetails = function(param) {
    var content = param.content, translations = param.translations;
    var locale = Runtime.useLocale();
    var dateLong = String.dateFormats[locale.language].dateLong;
    return /*#__PURE__*/ _jsx("div", {
        children: Object.entries(content).map(function(param) {
            var _param = _sliced_to_array(param, 2), category = _param[0], data = _param[1];
            return /*#__PURE__*/ _jsxs(Category, {
                children: [
                    /*#__PURE__*/ _jsx(Ui.Typography, {
                        as: "h2",
                        children: translations.carTypes[category]
                    }),
                    data.offers.map(function(offer) {
                        var destinationDate = new Date(offer.destinationDate);
                        return /*#__PURE__*/ _jsxs(Details, {
                            children: [
                                /*#__PURE__*/ _jsxs(Pricing, {
                                    children: [
                                        /*#__PURE__*/ _jsx(BodyText, {
                                            children: offer.supplier
                                        }),
                                        /*#__PURE__*/ _jsxs(BodyText, {
                                            children: [
                                                translations.pricePrefix,
                                                offer.price,
                                                "€ ",
                                                translations.priceSuffix
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Dates, {
                                    textColor: "grey",
                                    children: [
                                        differenceInCalendarDays(parseISO(offer.destinationDate), parseISO(offer.departureDate)),
                                        translations.durationFrom,
                                        format(destinationDate, dateLong),
                                        "; ",
                                        offer.city
                                    ]
                                })
                            ]
                        }, "".concat(offer.category, "-").concat(offer.supplier));
                    })
                ]
            }, category);
        })
    });
};
export { OfferDetails };
